

import useAuth from 'hooks/useAuth';
import { useSelector } from 'store';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const organization: any = useSelector((state) => state.organization);
  const { user } = useAuth();

  let siteName: string;

  if (organization?.setting?.identity?.site_name) {
    siteName = organization.setting.identity.site_name;
  } else if (user?.type === 'superadmin') {
    siteName = 'Super Admin';
  } else if (user?.type === 'support') {
    siteName = 'Support';
  } else {
    siteName = organization?.name;
  }


  return (
 
    
      <h3
        className="mainlogo"
        style={{ textTransform: 'capitalize', color: user?.type === 'student' ? '#fff' : 'primary', whiteSpace: 'normal' }}
      >
    {siteName}
      </h3>
    
  );
};

export default LogoMain;
